import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueCompositionApi, { ref, onUnmounted, onMounted } from '@vue/composition-api';
import Vue from 'vue';
import { clickBuyNowLog, clickNotBuyLog, showBuyNowLog, showNotBuyLog } from './eventTracking';
import Drip from 'drip';
import { dateFormat } from '@/utils/';
import GroupPurchaseCountDown from '@/components/GroupPurchaseCountDown/index';
Vue.use(VueCompositionApi);
export default {
  props: ['item', 'onlyOneItem', 'performanceId', 'cityId'],
  components: {
    GroupPurchaseCountDown: GroupPurchaseCountDown
  },
  setup: function setup(props) {
    var _props$item = props.item,
      currentTime = _props$item.currentTime,
      startTime = _props$item.startTime;
    var timeIsEnd = ref(false); //0:未到时间，1:到时间
    var interval = ref(null);
    var dividerTime = startTime - currentTime;
    if (currentTime >= startTime) {
      timeIsEnd.value = true;
    } else {
      if (dividerTime < 300000) {
        //五分钟开始倒计时
        startCountTime();
      }
    }
    function startCountTime() {
      clearInterval(interval.value);
      var s = dividerTime / 1000;
      var count = 0;
      interval.value = setInterval(function () {
        count++;
        if (count >= s) {
          timeIsEnd.value = true;
          clearInterval(interval.value);
        }
      }, 1000);
    }
    onUnmounted(function () {
      clearInterval(interval.value);
    });
    var sellTime = dateFormat(startTime, 'MM月dd日 hh:mm开抢');
    var queryUrl = function queryUrl(url, query) {
      var _url = url;
      Object.keys(query).forEach(function (key) {
        if (_url.includes('?')) {
          _url = "".concat(_url, "&").concat(key, "=").concat(query[key]);
        } else {
          _url = "".concat(_url, "?").concat(key, "=").concat(query[key]);
        }
      });
      return _url;
    };
    var handleClick = function handleClick() {
      if (timeIsEnd.value) {
        clickBuyNowLog(props.performanceId, props.item.productId);
      } else {
        clickNotBuyLog(props.performanceId, props.item.productId);
      }
      Drip.redirect(queryUrl(props.item.detailLink, {
        cityId: props.cityId
      }));
    };
    onMounted(function () {
      if (timeIsEnd.value) {
        showBuyNowLog(props.performanceId, props.item.productId);
      } else {
        showNotBuyLog(props.performanceId, props.item.productId);
      }
    });
    return {
      timeIsEnd: timeIsEnd,
      sellTime: sellTime,
      handleClick: handleClick
    };
  },
  methods: {
    onCountDownFinish: function onCountDownFinish() {
      this.$emit('onCountDownFinish');
    }
  }
};